import { render, staticRenderFns } from "./tm-order-type-picker.vue?vue&type=template&id=2aeb80ed&scoped=true&"
import script from "./tm-order-type-picker.vue?vue&type=script&lang=ts&"
export * from "./tm-order-type-picker.vue?vue&type=script&lang=ts&"
import style0 from "./tm-order-type-picker.vue?vue&type=style&index=0&id=2aeb80ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb80ed",
  null
  
)

export default component.exports